module.exports = __webpack_public_path__ + "static/media/logo.12cd31fe.png";